<template>
    <div id="journal">
        <el-container>
            <el-header>
                <top-Nav></top-Nav>
            </el-header>
            <el-main>

                    <div>
                        <div class="mainHead">
                            <div class="route">
                                <span class="crumbs"></span><span>日志</span>
                            </div>
                            <div>
                                <el-date-picker
                                    v-model="customData"
                                    @change="changeTime"
                                    value-format="yyyy-MM-dd"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                  <div class="fixedScorll"  :style="{height:basicHeight+'px'}">
                    <div v-show="tableData.length>0" class="tabs table_data">
                      <el-table :data="tableData" style="width: 100%" border>
                        <el-table-column prop="index" label="序号" width="70" fixed></el-table-column>
                        <el-table-column prop="accessTime" label="访问时间"  min-width="180"></el-table-column>
                        <el-table-column prop="module" label="业务模块"  min-width="120"></el-table-column>
                        <el-table-column prop="userName" label="姓名"  min-width="120"></el-table-column>
                        <el-table-column prop="userNumber" label="工号"  min-width="140"></el-table-column>
                        <el-table-column prop="loginName" label="账号"  min-width="180"></el-table-column>
                        <el-table-column prop="date3" label="日志类型"  min-width="120">
                          <template slot-scope="scope">
                            <div v-if="scope.row.logType==1">服务日志</div>
                            <div v-else-if="scope.row.logType==2">操作日志</div>
                            <div v-else-if="scope.row.logType==3">系统日志</div>
                            <div v-else>--</div>
                          </template>
                        </el-table-column>
                        <el-table-column label="日志内容" min-width="356">
                          <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.content" placement="bottom-start" :disabled="clientText>=overflowText">
                              <div class="over_text" @mouseover="changeText($event)">{{scope.row.content}}</div>
                            </el-tooltip>

                          </template>
                        </el-table-column>
                      </el-table>
                      <div style="text-align: right;margin-top: 15px" v-if="total>20">
                        <el-pagination  @current-change="handleCurrentChange1" :current-page.sync="params.currentPage" :page-size="20" layout="prev, pager, next" :total='total' background></el-pagination>
                      </div>
                    </div>
                    <div class="No" v-show="tableData.length===0">
                      <img src="../../../static/img/Nodata.png">
                      <span>暂无数据</span>
                    </div>
                  </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import topNav from '../../components/TopNav.vue';
    import {ajaxFuncJson} from '@/api/ajax';
    export default {
        name: 'journal',
        data() {
            return {
                msg: '日志',
                customData:'',
                tableData: [],
                params:{
                  currentPage:1,
                  pageSize:20,
                  start:'',
                  end:'',
                  showTime:''        //customize 筛选有时间
                },
              total:0,
              basicHeight:0,
              overflowText:'',
              clientText:'',
              windowResize:null,
            }
        },
        created(){
          if(this.isAuth('common:interface')){
            this.getNoteData();
          }
        },
        mounted() {
          let that = this;
          that.windowResize= function () {
            that.basicHeight=$('body').height()-$('.mainHead').outerHeight(true)-71;
            that.isScroll();
          };
          that.windowResize();
          window.addEventListener('resize',that.windowResize);
        },
        methods: {
          changeText(event){
            this.clientText=event.srcElement.clientWidth;
            this.overflowText=event.srcElement.scrollWidth;
          },
          isScroll(){
            this.$nextTick(()=>{
              let sHeight=document.getElementsByClassName('fixedScorll')[0].scrollHeight,
                cHeight=document.getElementsByClassName('fixedScorll')[0].clientHeight;
              if(sHeight>cHeight){
                document.getElementsByClassName('fixedScorll')[0].style.marginRight='3px';
              }else {
                document.getElementsByClassName('fixedScorll')[0].style.marginRight='20px';
              }
            });
          },
          getNoteData(){
              ajaxFuncJson('/loginfo/findOperatLog',this.params).then(res=>{
                  if(res.data.status==200){
                    this.tableData=res.data.data.rows;
                    if(this.tableData.length>0){
                      this.tableData.forEach((item,index)=>{
                        this.$set(item,'index',20*(this.params.currentPage-1)+(index+1));
                        this.tableData[index].accessTime=this.formatDate(item.accessTime);
                      })
                    }
                    this.total=res.data.data.total;
                    this.isScroll();
                  }else {
                    this.$message({
                      message:res.data.msg,
                      type:'error'
                    })
                  }
              });
          },
           add0(m){
            return m<10?'0'+m:m
           },
           formatDate(needTime){
            //needTime是整数，否则要parseInt转换
            var time = new Date(needTime);
            var y = time.getFullYear();
            var m = time.getMonth()+1;
            var d = time.getDate();
            var h = time.getHours();
            var mm = time.getMinutes();
            var s = time.getSeconds();
            return y+'-'+this.add0(m)+'-'+this.add0(d)+' '+this.add0(h)+':'+this.add0(mm)+':'+this.add0(s);
          },
            //分页按钮
            handleCurrentChange1(val){
              this.getNoteData();
            },
          changeTime(val){
            this.params.currentPage=1;
            if(val){
              this.params.start=val[0];
              this.params.end=val[1];
              this.params.showTime='customize';
            }else {
              this.params.start='';
              this.params.end='';
              this.params.showTime='';
            }
            this.getNoteData();
          }
        },
        destroyed(){
          let _this=this;
          window.removeEventListener("resize",_this.windowResize)
        },
        components: {
            topNav,
        }
    }
</script>
<style lang="scss" scope>
    @import "@/assets/css/mixin.scss";
    #journal {
        height: 100%;
        .el-container {
            height: 100%;
            .el-main {
              width: 100% !important;
              margin: 0 !important;
              background: #f2f2f2;


              .mainHead {
                margin: 10px 20px 0 20px;

                .el-range-editor--small.el-input__inner {
                  margin-right: 0;
                }
              }
            }
        }
      .tabs{
        padding: 20px 20px 0 20px;
      }
      .fixedScorll{
        background: #fff;
        margin-left: 20px;
        margin-right: 20px;
        .over_text{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-right: 13px;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/page/systemManger/journal.vue